import { ApexOptions } from 'apexcharts';
import theme from '../../../../../../styles/theme';

interface IUseAppDownloadChartOptions {
  labels: string[];
  series: number[];
}
const useAppDownloadChartOptions = ({
  labels,
  series,
}: IUseAppDownloadChartOptions): ApexOptions =>
  ({
    chart: {
      toolbar: {
        show: false,
      },
      foreColor: theme.colors.gray[500],
    },
    colors: ['#2E93fA'],
    grid: {
      show: false,
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        distributed: true,
        columnWidth: '98%',
        borderRadius: 4,
      },
    },
    series: [{ name: 'clientes', data: series }],
    xaxis: {
      type: 'category',
      axisBorder: {
        color: theme.colors.gray[400],
      },
      axisTicks: {
        color: theme.colors.gray[400],
      },
      categories: labels,
    },
    yaxis: {
      labels: {
        formatter: (value) => value.toString(),
      },
    },
  } as ApexOptions);

export default useAppDownloadChartOptions;
